import type { DragType } from "@v1/types/drag-type";

import {
  selectCurrentDraggingIdentifier,
  selectCurrentDragType,
  setCurrentDragTypeAndIdentifier,
} from "@v1/reducers/drag-and-drop-reducer";
import { useEditorDispatch, useEditorSelector } from "@v1/store/store";

export default function useCurrentDragType() {
  const currentDragType = useEditorSelector(selectCurrentDragType);
  const currentDragIdentifier = useEditorSelector(
    selectCurrentDraggingIdentifier,
  );
  const dispatch = useEditorDispatch();

  return {
    currentDragType,
    currentDragIdentifier,
    setCurrentDragTypeAndIdentifier: (
      currentDragType: DragType | null,
      identifier: string | null,
    ) => {
      return dispatch(
        setCurrentDragTypeAndIdentifier({
          dragType: currentDragType,
          identifier,
        }),
      );
    },
  };
}
